module.exports = __webpack_public_path__ + "assets/usp-check-mark.e09bb1e9.svg";